import React, { ReactNode, useState } from 'react';

import Tooltip from 'component/Layout/Tooltip';

import classNames from 'classnames';

import { ReactComponent as IconCross } from 'media/svg/cross.svg';

import styles from './Box.module.scss';

export enum BoxType {
    DEFAULT = 'Default',
    INFO = 'Info',
    POSITIVE = 'Positive',
    NEGATIVE = 'Negative',
    WARNING = 'Warning',
}

export enum IconPosition {
    LEFT = 'Left',
    Right = 'Right',
}

export interface BoxProps {
    /** The type of the Message */
    type?: BoxType;
    /** Scracity Box */
    isScarcity?: boolean;
    /** custom ClassList */
    customClassList?: {
        Box?: string;
        Icon?: string;
    };
    /** Icon as Component */
    icon?: ReactNode;
    /** callback when closing the box */
    onCloseCallback?: () => void;
    /** is it closable? if callback given value is ignored  */
    closeable?: boolean;
    tooltipAlign?: {
        offset: number[];
    };
    iconTooltipContent?: React.ReactNode;
}

const Box: React.FC<React.PropsWithChildren<BoxProps>> = ({
    type = BoxType.DEFAULT,
    children,
    isScarcity,
    icon,
    customClassList,
    closeable = false,
    onCloseCallback,
    tooltipAlign,
    iconTooltipContent,
    ...rest
}) => {
    const [closed, setClosed] = useState(false);
    if (closed) {
        return null;
    }

    return (
        <aside
            className={classNames(
                styles.Box,
                styles[type],
                {
                    [styles.IconBox]: icon,
                    [styles.Scarcity]: isScarcity,
                    [styles.Closeable]: closeable || onCloseCallback,
                },
                customClassList?.Box
            )}
            {...rest}
        >
            {(closeable || onCloseCallback) && (
                <div
                    className={styles.Close}
                    onKeyDown={() => { }}
                    onClick={() => {
                        setClosed(true);
                        if (!!onCloseCallback) {
                            onCloseCallback();
                        }
                    }}
                    role="button"
                    tabIndex={0}
                >
                    <IconCross />
                </div>
            )}
            {/* With Tooltip */}
            {!!iconTooltipContent && icon && (
                <Tooltip align={tooltipAlign} content={iconTooltipContent}>
                    <div
                        className={classNames(
                            customClassList?.Icon,
                            styles.Icon
                        )}
                    >
                        {icon}
                    </div>
                </Tooltip>
            )}
            {/* Without Tooltip */}
            {!iconTooltipContent && icon && (
                <div className={classNames(customClassList?.Icon, styles.Icon)}>
                    {icon}
                </div>
            )}
            <div>{children}</div>
        </aside>
    );
};

export default Box;
